import { useQuery } from "react-query";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";
import getPaymentReconciliationData, {
  PaymentReconciliationResponse,
} from "../services/getPaymentReconciliationData";

function useGetPaymentReconciliationData(
  token: string,
  pagination: MRT_PaginationState,
  columnFilters: MRT_ColumnFiltersState,
  sorting: MRT_SortingState
) {
  return useQuery<PaymentReconciliationResponse>({
    queryKey: ["get-payment-reconciliation-data", pagination, columnFilters, sorting],
    queryFn: () =>
      getPaymentReconciliationData({ token, pagination, columnFilters, sorting }),
    retry: false,
    keepPreviousData: true,
    staleTime: 30_000,
  });
}

export default useGetPaymentReconciliationData;